import React,{useEffect} from "react";
import "./printable-pdf-preview.scss";

interface PrintablePDFPreviewProps {
  pdfUrl: string;
}

const PrintablePDFPreview: React.FC<PrintablePDFPreviewProps> = ({ pdfUrl }) => {
  
  useEffect(() => {
    // This effect can be used to handle any side effects when the component mounts
    console.log("PrintablePDFPreview component mounted with URL:", pdfUrl);
  }, [pdfUrl]);

  return (
    <div className="printable-pdf-preview">
      <div className="print-options">
        <h3>Options to Print</h3>
        <div className="print-instructions">
          <p>1. Click the printer icon</p>
          <p>2. Download the PDF then print</p>
          <p>3. Right click on the document and choose print</p>
        </div>
      </div>
      <div className="pdf-viewer">
        <iframe
          src={pdfUrl}
          title="Letter Preview"
          width="100%"
          height="490px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
};

export default PrintablePDFPreview;
